import { Injectable } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { of } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { shareReplay } from 'rxjs/operators';
import { SimpleVideo } from '@portal/models/simpleVideo';
import { VideoFrameService } from './video-frame.service';

const VIDEO_POSTER_CACHE_MAX_ENTRIES = 100;

interface VideoPosterCacheEntry {
  key: string;
  stream$: Observable<SafeUrl | null>;
}

@Injectable({ providedIn: 'root' })
export class VideoPosterService {
  private readonly cache: VideoPosterCacheEntry[] = [];

  constructor(private readonly frameService: VideoFrameService) {}

  getPoster(value: SimpleVideo | string | null | undefined): Observable<SafeUrl | null> {
    if (!value) {
      return of(null);
    }
    const key = typeof value === 'string' ? value : value.path;
    if (!key) {
      return of(null);
    }
    const index = this.cache.findIndex(entry => entry.key === key);
    if (index !== -1) {
      const [entry] = this.cache.splice(index, 1);
      this.cache.push(entry);
      return entry.stream$;
    }
    if (this.cache.length >= VIDEO_POSTER_CACHE_MAX_ENTRIES) {
      this.cache.shift();
    }
    const stream$ = this.frameService.capture(value).pipe(shareReplay({ bufferSize: 1, refCount: false }));
    this.cache.push({ key, stream$ });

    return stream$;
  }
}
